<template>
  <div class="notificationItem p-3">
    <div>
      {{ this.notification.label }}<br />
      <span class="notificationItemDate" style="color: #777; font-size: 12px">{{
        moment(this.notification.created).format("LL")
      }}</span>
    </div>

    <div class="d-flex justify-content-end mt-2">
      <div v-if="handled">
        <span :style="handleActionColor(handledText)">{{ handledText }}</span>
      </div>
      <div v-else>
        <span
          class="mx-1"
          v-for="action in this.notification.actions"
          :key="action.url"
        >
          <button
            :class="handleActionBtn(action.label)"
            @click="handleAction(action)"
          >
            {{ action.label }}
          </button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { eventBus } from "../../main";

export default {
  name: "NotificationItem",
  props: {
    notification: Object,
  },
  data() {
    return {
      handled: false,
      handledText: "",
    };
  },
  methods: {
    handleActionColor(action) {
      let style = "";
      action === "Accept" || action === "Accepted!"
        ? (style = "color: green")
        : action === "Reject" || action === "Rejected!"
        ? (style = "color: red")
        : (style = "color: grey");
      return style;
    },
    handleActionBtn(action) {
      let className = "";
      action === "Accept"
        ? (className = "btn btn-sm btn-outline-success")
        :
        action === "Accept User"
        ? (className = "btn btn-sm btn-outline-success")
        :  
        action === "Join Group"
        ? (className = "btn btn-sm btn-outline-success")
        :       
        action === "Reject"
        ? (className = "btn btn-sm btn-outline-danger")
        : 
        action === "Reject User"
        ? (className = "btn btn-sm btn-outline-danger")
        :        
        action === "Dismiss"
        ? (className = "btn btn-sm btn-outline-secondary")
        : (className = "");
      return className;
    },
    handleAction(action) {
      if (action.label === "Join Group" || action.label === "Reject" ||
      action.label === "Accept User" || action.label === "Reject User"
      ) {
        axios
          .post(action.url, null, { withCredentials: true })
          .then((response) => {
            console.log(response)
            this.handled = true;
            this.handledText =
              action.label === "Join Group" ? "Joined!" :
              "Accept User" ? "Accepted!" :
              "Rejected!";
            if (action.label === "Join Group" ){

 eventBus.$emit("NotificationClick")

            }
            if (action.label === "Accept User" ){
eventBus.$emit("NotificationClick")
            }
          })
          .catch((error) => console.info(error));
      } 
      else {
        axios
          .delete(action.url, { withCredentials: true })
          .then((response) => {
            console.log(response)
            this.handled = true;
            this.handledText = "Dismissed!";
            eventBus.$emit("NotificationClick");
          })
          .catch((error) => console.info(error));
      }
    },
  },
};
</script>

<style scoped>
.notificationItem:hover {
  background: #eee;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/notifications/NotificationItem.vue